import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/auth/actions";
import { useEffect, useRef, useState } from "react";
import { selectCurrent } from "../../redux/settings/selectors";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { selectCmsSettingsListItems } from "../../redux/cmsSettings/selector";

const TransportAgentSidebar = () => {
	let items: any = []
	let subitems: any = []
	const result = useSelector(selectCurrent)
	const { sidebar, theme } = result
	const [activeIndex, setActiveIndex] = useState(null);
	const [activeSubIndex, setActiveSubIndex] = useState(null);
	const navigate = useNavigate()
	const [open, setOpen] = useState(items)
	const [subOpen, setSubOpen] = useState(subitems)
	const cmsSettings = useSelector(selectCmsSettingsListItems)
	const dropdownRef = useRef<HTMLDivElement>(null);
	const [menus, setMenus] = useState([
		{
			id: `main-menu-2-all`,
			label: 'Dashboard',
			path: '/transport-agent/home',
			isEnabled: true,
			svg: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5" color="#ffffff" fill="none">
					<path d="M2 6C2 4.11438 2 3.17157 2.58579 2.58579C3.17157 2 4.11438 2 6 2C7.88562 2 8.82843 2 9.41421 2.58579C10 3.17157 10 4.11438 10 6V8C10 9.88562 10 10.8284 9.41421 11.4142C8.82843 12 7.88562 12 6 12C4.11438 12 3.17157 12 2.58579 11.4142C2 10.8284 2 9.88562 2 8V6Z" stroke="currentColor" stroke-width="1.5" />
					<path d="M2 19C2 18.0681 2 17.6022 2.15224 17.2346C2.35523 16.7446 2.74458 16.3552 3.23463 16.1522C3.60218 16 4.06812 16 5 16H7C7.93188 16 8.39782 16 8.76537 16.1522C9.25542 16.3552 9.64477 16.7446 9.84776 17.2346C10 17.6022 10 18.0681 10 19C10 19.9319 10 20.3978 9.84776 20.7654C9.64477 21.2554 9.25542 21.6448 8.76537 21.8478C8.39782 22 7.93188 22 7 22H5C4.06812 22 3.60218 22 3.23463 21.8478C2.74458 21.6448 2.35523 21.2554 2.15224 20.7654C2 20.3978 2 19.9319 2 19Z" stroke="currentColor" stroke-width="1.5" />
					<path d="M14 16C14 14.1144 14 13.1716 14.5858 12.5858C15.1716 12 16.1144 12 18 12C19.8856 12 20.8284 12 21.4142 12.5858C22 13.1716 22 14.1144 22 16V18C22 19.8856 22 20.8284 21.4142 21.4142C20.8284 22 19.8856 22 18 22C16.1144 22 15.1716 22 14.5858 21.4142C14 20.8284 14 19.8856 14 18V16Z" stroke="currentColor" stroke-width="1.5" />
					<path d="M14 5C14 4.06812 14 3.60218 14.1522 3.23463C14.3552 2.74458 14.7446 2.35523 15.2346 2.15224C15.6022 2 16.0681 2 17 2H19C19.9319 2 20.3978 2 20.7654 2.15224C21.2554 2.35523 21.6448 2.74458 21.8478 3.23463C22 3.60218 22 4.06812 22 5C22 5.93188 22 6.39782 21.8478 6.76537C21.6448 7.25542 21.2554 7.64477 20.7654 7.84776C20.3978 8 19.9319 8 19 8H17C16.0681 8 15.6022 8 15.2346 7.84776C14.7446 7.64477 14.3552 7.25542 14.1522 6.76537C14 6.39782 14 5.93188 14 5Z" stroke="currentColor" stroke-width="1.5" />
				</svg>

			),
		},
		{
			id: `main-menu-2-all`,
			path: '/transport-agent/bookings/parcel',
			label: 'Bookings',
			isEnabled: true,
			svg: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5" color="#ffffff" fill="none">
					<path d="M18 2V4M6 2V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M11.05 22C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.4765 5.68186 21.4996 7.80438 21.5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M3 8H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M13 18H21M17 14L17 22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
				</svg>

			),
			subMenu: [
				{
					id: `coln-1-collections`,
					label: 'Parcel',
					path: '/transport-agent/bookings/parcel',
					isEnabled: true,
					svg: (
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5" color="#ffffff" fill="none">
							<path d="M12 22C11.1818 22 10.4002 21.6698 8.83693 21.0095C4.94564 19.3657 3 18.5438 3 17.1613C3 16.7742 3 10.0645 3 7M12 22C12.8182 22 13.5998 21.6698 15.1631 21.0095C19.0544 19.3657 21 18.5438 21 17.1613V7M12 22L12 11.3548" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							<path d="M8.32592 9.69138L5.40472 8.27785C3.80157 7.5021 3 7.11423 3 6.5C3 5.88577 3.80157 5.4979 5.40472 4.72215L8.32592 3.30862C10.1288 2.43621 11.0303 2 12 2C12.9697 2 13.8712 2.4362 15.6741 3.30862L18.5953 4.72215C20.1984 5.4979 21 5.88577 21 6.5C21 7.11423 20.1984 7.5021 18.5953 8.27785L15.6741 9.69138C13.8712 10.5638 12.9697 11 12 11C11.0303 11 10.1288 10.5638 8.32592 9.69138Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							<path d="M6 12L8 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							<path d="M17 4L7 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
						</svg>

					),
				},
				{
					id: `coln-1-collections`,
					label: 'Cargo',
					path: '/transport-agent/bookings/cargo',
					isEnabled: cmsSettings?.result?.items?.LogisticsSettings?.Cargo ? true : false,
					svg: (
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5" color="#ffffff" fill="none">
							<circle cx="17" cy="18" r="2" stroke="currentColor" stroke-width="1.5" />
							<circle cx="7" cy="18" r="2" stroke="currentColor" stroke-width="1.5" />
							<path d="M11 17H15M13.5 7H14.4429C15.7533 7 16.4086 7 16.9641 7.31452C17.5196 7.62904 17.89 8.20972 18.6308 9.37107C19.1502 10.1854 19.6955 10.7765 20.4622 11.3024C21.2341 11.8318 21.6012 12.0906 21.8049 12.506C22 12.9038 22 13.375 22 14.3173C22 15.5596 22 16.1808 21.651 16.5755C21.636 16.5925 21.6207 16.609 21.6049 16.625C21.2375 17 20.6594 17 19.503 17H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							<path d="M13 7L13.9942 9.48556C14.4813 10.7034 14.7249 11.3123 15.2328 11.6561C15.7407 12 16.3965 12 17.7081 12H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							<path d="M4.86957 17C3.51684 17 2.84048 17 2.42024 16.5607C2 16.1213 2 15.4142 2 14V7C2 5.58579 2 4.87868 2.42024 4.43934C2.84048 4 3.51684 4 4.86957 4H10.1304C11.4832 4 12.1595 4 12.5798 4.43934C13 4.87868 13 5.58579 13 7V17H8.69565" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
						</svg>

					),
				}]
		},
		{
			id: `main-menu-2-all`,
			label: 'Jobs',
			path: '/transport-agent/logistics/transport/jobs',
			isEnabled: true,
			svg: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5" color="#ffffff" fill="none">
					<path d="M11.0065 21.0001H9.60546C6.02021 21.0001 4.22759 21.0001 3.11379 19.8652C2 18.7302 2 16.9035 2 13.2501C2 9.59674 2 7.77004 3.11379 6.63508C4.22759 5.50012 6.02021 5.50012 9.60546 5.50012H13.4082C16.9934 5.50012 18.7861 5.50012 19.8999 6.63508C20.7568 7.50831 20.9544 8.79102 21 11.0001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
					<path d="M17.111 13.2551C17.2956 13.085 17.3879 13 17.5 13C17.6121 13 17.7044 13.085 17.889 13.2551L18.6017 13.9117C18.6878 13.991 18.7308 14.0307 18.7843 14.0503C18.8378 14.07 18.8963 14.0677 19.0133 14.0631L19.9762 14.0253C20.2241 14.0155 20.3481 14.0107 20.4331 14.0821C20.5181 14.1535 20.5346 14.2765 20.5677 14.5224L20.7004 15.5077C20.7157 15.6216 20.7234 15.6785 20.7511 15.7271C20.7789 15.7757 20.824 15.8112 20.9143 15.8823L21.6898 16.4928C21.8817 16.6439 21.9777 16.7194 21.9967 16.8274C22.0157 16.9354 21.9513 17.0391 21.8225 17.2467L21.2965 18.0943C21.2363 18.1913 21.2063 18.2398 21.1967 18.2946C21.1871 18.3493 21.199 18.4052 21.2228 18.5168L21.4315 19.4952C21.4827 19.7356 21.5084 19.8558 21.4533 19.9513C21.3983 20.0467 21.2814 20.0848 21.0477 20.1609L20.122 20.4624C20.0117 20.4983 19.9565 20.5163 19.9134 20.5528C19.8703 20.5894 19.8436 20.6409 19.7902 20.7439L19.338 21.6154C19.2227 21.8375 19.1651 21.9485 19.0601 21.9868C18.9551 22.0251 18.8395 21.9772 18.6084 21.8813L17.72 21.5128C17.6114 21.4678 17.5572 21.4453 17.5 21.4453C17.4428 21.4453 17.3886 21.4678 17.28 21.5128L16.3916 21.8813C16.1605 21.9772 16.0449 22.0251 15.9399 21.9868C15.8349 21.9485 15.7773 21.8375 15.662 21.6154L15.2098 20.7439C15.1564 20.6409 15.1297 20.5894 15.0866 20.5528C15.0435 20.5163 14.9883 20.4983 14.878 20.4624L13.9523 20.1609C13.7186 20.0848 13.6017 20.0467 13.5467 19.9513C13.4916 19.8558 13.5173 19.7356 13.5685 19.4952L13.7772 18.5168C13.801 18.4052 13.8129 18.3493 13.8033 18.2946C13.7937 18.2398 13.7637 18.1913 13.7035 18.0943L13.1775 17.2467C13.0487 17.0391 12.9843 16.9354 13.0033 16.8274C13.0223 16.7194 13.1183 16.6439 13.3102 16.4928L14.0857 15.8823C14.176 15.8112 14.2211 15.7757 14.2489 15.7271C14.2766 15.6785 14.2843 15.6216 14.2996 15.5077L14.4323 14.5224C14.4654 14.2765 14.4819 14.1535 14.5669 14.0821C14.6519 14.0107 14.7759 14.0155 15.0238 14.0253L15.9867 14.0631C16.1037 14.0677 16.1622 14.07 16.2157 14.0503C16.2692 14.0307 16.3122 13.991 16.3983 13.9117L17.111 13.2551Z" stroke="currentColor" stroke-width="1.5" />
					<path d="M15.9998 5.5L15.9004 5.19094C15.4054 3.65089 15.1579 2.88087 14.5686 2.44043C13.9794 2 13.1967 2 11.6313 2H11.3682C9.8028 2 9.02011 2 8.43087 2.44043C7.84162 2.88087 7.59411 3.65089 7.0991 5.19094L6.99976 5.5" stroke="currentColor" stroke-width="1.5" />
				</svg>

			),
		},
		{
			id: `main-menu-2-all`,
			label: 'Trips',
			path: '/transport-agent/logistics/transport/trips',
			isEnabled: true,
			svg: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5" color="#ffffff" fill="none">
					<path d="M4 12L3.3436 12.9846C2.67671 13.9849 2.34326 14.4851 2.17163 15.052C2 15.6188 2 16.22 2 17.4222V20.5C2 20.9659 2 21.1989 2.07612 21.3827C2.17761 21.6277 2.37229 21.8224 2.61732 21.9239C2.80109 22 3.03406 22 3.5 22C3.96594 22 4.19891 22 4.38268 21.9239C4.62771 21.8224 4.82239 21.6277 4.92388 21.3827C5 21.1989 5 20.9659 5 20.5C5 20.0341 5 19.8011 5.07612 19.6173C5.17761 19.3723 5.37229 19.1776 5.61732 19.0761C5.80109 19 6.03406 19 6.5 19H17.5C17.9659 19 18.1989 19 18.3827 19.0761C18.6277 19.1776 18.8224 19.3723 18.9239 19.6173C19 19.8011 19 20.0341 19 20.5C19 20.9659 19 21.1989 19.0761 21.3827C19.1776 21.6277 19.3723 21.8224 19.6173 21.9239C19.8011 22 20.0341 22 20.5 22C20.9659 22 21.1989 22 21.3827 21.9239C21.6277 21.8224 21.8224 21.6277 21.9239 21.3827C22 21.1989 22 20.9659 22 20.5V17.4222C22 16.22 22 15.6188 21.8284 15.052C21.6567 14.4851 21.3233 13.9849 20.6564 12.9846L20 12L18.4777 12.3806C18.2392 12.4402 18.1199 12.47 17.9982 12.485C17.8764 12.5 17.7535 12.5 17.5076 12.5H6.49242C6.24652 12.5 6.12357 12.5 6.00184 12.485C5.88012 12.47 5.76084 12.4402 5.52228 12.3806L4 12ZM4 12L4.96154 9.69231C5.70726 7.90257 6.08013 7.0077 6.8359 6.50385C7.59167 6 8.56112 6 10.5 6M4 12L2 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M18 16V16.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M6 16V16.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					<circle cx="17" cy="6" r="4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M17 4V6L18.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
				</svg>

			),
		},
		{
			id: `main-menu-2-all`,
			label: 'Vehicle',
			path: '/transport-agent/logistics/transport/vehicle-registations',
			isEnabled: true,
			svg: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5" color="#ffffff" fill="none">
					<circle cx="17" cy="18" r="2" stroke="currentColor" stroke-width="1.5" />
					<circle cx="7" cy="18" r="2" stroke="currentColor" stroke-width="1.5" />
					<path d="M11 17H15M13.5 7H14.4429C15.7533 7 16.4086 7 16.9641 7.31452C17.5196 7.62904 17.89 8.20972 18.6308 9.37107C19.1502 10.1854 19.6955 10.7765 20.4622 11.3024C21.2341 11.8318 21.6012 12.0906 21.8049 12.506C22 12.9038 22 13.375 22 14.3173C22 15.5596 22 16.1808 21.651 16.5755C21.636 16.5925 21.6207 16.609 21.6049 16.625C21.2375 17 20.6594 17 19.503 17H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M13 7L13.9942 9.48556C14.4813 10.7034 14.7249 11.3123 15.2328 11.6561C15.7407 12 16.3965 12 17.7081 12H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M4.86957 17C3.51684 17 2.84048 17 2.42024 16.5607C2 16.1213 2 15.4142 2 14V7C2 5.58579 2 4.87868 2.42024 4.43934C2.84048 4 3.51684 4 4.86957 4H10.1304C11.4832 4 12.1595 4 12.5798 4.43934C13 4.87868 13 5.58579 13 7V17H8.69565" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
			),
		}

	])

	const filteredMenus = menus
		.map(menu => ({
			...menu,
			subMenu: menu.subMenu ? menu.subMenu.filter(sub => sub.isEnabled) : [],
		}))
		.filter(menu => menu.isEnabled || menu.subMenu.length > 0);

	useEffect(() => {
		filteredMenus?.map((item: any) => {
			items.push({ open: true, isActive: false })
			item?.subMenu?.map((obj: any) => {
				subitems.push({ open: true, isActive: false })
			})

		})
	}, [filteredMenus])

	const beginWord = (sentence: string | undefined | null) => {
		if (!sentence || typeof sentence !== 'string') {
			return '';
		}

		const words = sentence.trim().split(/\s+/);

		if (words.length === 0) {
			return '';
		}
		if (sentence.length > 19) {
			const lastWord = words.pop() as string;
			let transformedSentence = ""
			if (words.length == 1) {
				transformedSentence = `${words[0]} `;
			}
			else if (words.length == 2)
				transformedSentence = `${words[0]} ${words[1]}`;
			return transformedSentence
		}
		else {
			return sentence
		}
	}

	const endWord = (sentence: string | undefined | null) => {
		if (!sentence || typeof sentence !== 'string') {
			return '';
		}

		const words = sentence.trim().split(/\s+/);

		if (words.length === 0) {
			return '';
		}
		if (sentence.length > 19) {
			const lastWord = words.pop() as string;
			return lastWord
		}

	}
	const dispatch = useAppDispatch();

	const handleNavigate = (path: any) => {
		navigate(`${path}`)
	}

	const handleMenu = (index: any, index1: any) => {
		let menu = [...open]
		open?.map((obj: any, idx: any) => {
			if (idx == index) {
				menu[idx].open = !obj.open
				menu[idx].isActive = true
			}
			else {
				menu[idx].open = true
				menu[idx].isActive = false
			}
		})
		setOpen(menu)
	}

	const handleSubMenu = (e: any, index: any) => {
		e.stopPropagation()
		let menu = [...subOpen]
		subOpen?.map((obj: any, idx: any) => {
			if (idx == index) {
				menu[idx].open = !obj.open
				menu[idx].isActive = true
			}
			else {
				menu[idx].open = true
				menu[idx].isActive = false
			}
		})
		setSubOpen(menu)
	}

	const handleClickOutside = (event: MouseEvent) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
			let menu = [...open]
			open?.map((obj: any, idx: any) => {
				// menu[idx].isActive = false
				menu[idx].open = true
			})
			setOpen(menu)
			let menu1 = [...subOpen]
			subOpen?.map((obj: any, idx: any) => {
				// menu1[idx].isActive = false
				menu1[idx].open = true
			})
			setSubOpen(menu1)

		}
	};

	useEffect(() => {

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [])
	return (
		<>

			{sidebar ? <div className="w-64 fixed md:top-0 md:left-0 h-screen lg:block bg-primary  z-10" >
				{sidebar &&
					<div className={`w-full flex flex-col justify-end items-end p-2 pr-4 mt-20 lg:mt-20 md:mt-20`}>
						<svg
							onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
							width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
							<title>Show Less Infomation</title>
							<path stroke-width="1.25" d="M12.6772 19.5377C12.9742 19.8265 13.449 19.8198 13.7377 19.5228C14.0265 19.2258 14.0198 18.751 13.7228 18.4623L12.6772 19.5377ZM6 12L5.47719 11.4623C5.33195 11.6035 5.25 11.7974 5.25 12C5.25 12.2026 5.33195 12.3965 5.47719 12.5377L6 12ZM13.7228 5.53775C14.0198 5.24901 14.0265 4.77418 13.7377 4.47719C13.449 4.1802 12.9742 4.17351 12.6772 4.46225L13.7228 5.53775ZM17.4772 18.3708C17.7742 18.6595 18.249 18.6528 18.5378 18.3558C18.8265 18.0588 18.8198 17.584 18.5228 17.2952L17.4772 18.3708ZM12 12L11.4772 11.4622C11.332 11.6035 11.25 11.7974 11.25 12C11.25 12.2026 11.332 12.3965 11.4772 12.5378L12 12ZM18.5228 6.70476C18.8198 6.41603 18.8265 5.9412 18.5378 5.64421C18.249 5.34721 17.7742 5.34051 17.4772 5.62924L18.5228 6.70476ZM13.7228 18.4623L6.52281 11.4623L5.47719 12.5377L12.6772 19.5377L13.7228 18.4623ZM6.52281 12.5377L13.7228 5.53775L12.6772 4.46225L5.47719 11.4623L6.52281 12.5377ZM18.5228 17.2952L12.5228 11.4622L11.4772 12.5378L17.4772 18.3708L18.5228 17.2952ZM12.5228 12.5378L18.5228 6.70476L17.4772 5.62924L11.4772 11.4622L12.5228 12.5378Z" fill="#f8f8f8" />
						</svg>
					</div>
				}
				<div className="h-[calc(100vh-10rem)] overflow-auto">
					<div className="mb-4  px-4 h-max ">

						{filteredMenus.map((obj: any, index1: any) => {
							return <li
								key={index1}
								onClick={() => handleMenu(index1, null)}
								className={`w-full flex flex-col justify-start space-y-3 `}>
								<div onClick={() => { !obj?.subMenu?.length && handleNavigate(obj?.path) }} className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary  hover:text-black" ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} `}>
									{obj?.svg}
									<span className="hover:text-black px-2 w-36 text-light text-sm ">{obj.label}</span>
								</div>
								{obj?.subMenu?.map((obj1: any, index2: any) => {
									return <ul
										key={index2}
										onClick={(e) => handleSubMenu(e, index2)}
										className={`w-full flex pl-2 flex-col justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'ml-2'} `}>
										<div onClick={() => handleNavigate(obj1?.path)} className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
											{obj1?.svg}
											<div className="text-light px-2 text-sm dark:text-slate-200 hover:text-black w-36  flex flex-col w-auto justify-center items-end">
												<span className="">{beginWord(obj1.label)}</span>
												<span className="text-right text-xs italic">{endWord(obj1.label)}</span>
											</div>
										</div> </ul>
								})}
							</li>
						})}
					</div>
				</div>
			</div> : <div ref={dropdownRef} className="w-24 fixed md:top-0 md:left-0 h-screen lg:block bg-primary  z-10" >

				<div className="">
					{!sidebar &&
						<div className={`w-full flex flex-col justify-end items-end p-2 mt-20 lg:mt-20 md:mt-20`}>
							<svg
								onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
								width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
								<title>Show More Infomation</title>
								<path stroke-width="1.25" d="M10.2772 18.4623C9.9802 18.751 9.97351 19.2258 10.2623 19.5228C10.551 19.8198 11.0258 19.8265 11.3228 19.5377L10.2772 18.4623ZM18 12L18.5228 12.5377C18.6681 12.3965 18.75 12.2026 18.75 12C18.75 11.7974 18.6681 11.6035 18.5228 11.4623L18 12ZM11.3228 4.46225C11.0258 4.17351 10.551 4.1802 10.2623 4.47719C9.97351 4.77418 9.9802 5.24901 10.2772 5.53775L11.3228 4.46225ZM5.47721 17.2952C5.18021 17.584 5.17351 18.0588 5.46224 18.3558C5.75097 18.6528 6.2258 18.6595 6.52279 18.3708L5.47721 17.2952ZM12 12L12.5228 12.5378C12.668 12.3965 12.75 12.2026 12.75 12C12.75 11.7974 12.668 11.6035 12.5228 11.4622L12 12ZM6.52279 5.62924C6.2258 5.34051 5.75097 5.34721 5.46224 5.64421C5.17351 5.9412 5.18021 6.41603 5.47721 6.70476L6.52279 5.62924ZM11.3228 19.5377L18.5228 12.5377L17.4772 11.4623L10.2772 18.4623L11.3228 19.5377ZM18.5228 11.4623L11.3228 4.46225L10.2772 5.53775L17.4772 12.5377L18.5228 11.4623ZM6.52279 18.3708L12.5228 12.5378L11.4772 11.4622L5.47721 17.2952L6.52279 18.3708ZM12.5228 11.4622L6.52279 5.62924L5.47721 6.70476L11.4772 12.5378L12.5228 11.4622Z" fill="#f8f8f8" />
							</svg>
						</div>
					}
					<div className="mb-4 px-4 h-max ">
						<ul className="w-full flex flex-col justify-start space-y-3">

							{filteredMenus.map((barmenu: any, index1: any) => {
								return <li
									className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 > 7 ? 'hidden' : ""} `}
									onClick={() => handleMenu(index1, null)} >
									<div onClick={() => { !barmenu?.subMenu?.length && handleNavigate(barmenu?.path) }} className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24  hover:text-black"`}>
										{barmenu?.svg}
									</div>
									{barmenu?.subMenu?.length > 0 &&
										<ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  bg-primary ml-0 ${index1 > 4 ? "mt-[calc(100vh-55rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
											{barmenu?.subMenu?.map((obj1: any, index2: any) => {
												return <ul
													onClick={(e) => handleSubMenu(e, index2)}
													className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
													<div onClick={() => handleNavigate(obj1?.path)} className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
														{obj1?.svg}
														<div className="text-light px-1 text-sm dark:text-slate-200 hover:text-black   flex flex-col w-auto justify-center items-end">

															<span className="">{beginWord(obj1.label)}</span>
															<span className="text-right text-xs italic">{endWord(obj1.label)}</span>
														</div>
													</div>

												</ul>
											})}
										</ul>}

								</li>
							})}

						</ul>
					</div>
				</div>
			</div>}


		</>
	)
}

export default TransportAgentSidebar;

